import LanguageDetector from 'i18next-browser-languagedetector';

const languageDetector = new LanguageDetector(null, {
  lookupLocalStorage: 'i18nextLng',
  order: ['localStorage', 'navigator'],
});

export default languageDetector;
